export const workTags = [
    {
        id: 1,
        tagName: "MUSIC"
    },
    {
        id: 2,
        tagName: "COMMERCIAL"
    },
  ]

  export const contactData ={
      showreelLink: "https://vimeo.com/1045725842/b91b22dfaf",
      numberStills: 12
  }

  export const homepageTransition = {
    'default' : {
      'duration' : 1,
      'delay' : 0
    },
    'project': {
      'duration' : 1,
      'delay': 1.5
    }
  }


  export const projData = [
    {
      title: "GEEKIN",
      artist: "Nafe Smallz",
      feature: ["AJ Tracey"],
      vimeo: "https://vimeo.com/1057132334/422c7b2c2b",
      aspectRatio: 4/3,
      tags : [1],
      credits: {
        director: "DON PROD",
        dop: "Michael R. Johsnon",
        first_ac: "Christian Wood",
        second_ac: "Antoine Law",
        first_ad: "Samuel Fullerton",
        second_ad: "Jodie Joy",
        lighting: "London Lighting",
        art: "Jordan Chandler",
        editor: "Samuel Maton",
        colourist: "Jared Rosenthal",
        sound_design: "Kai Goodrem",
        VFX: "Hwang Production",
        VHS: "4PM Recordings"
      },
      meta: {
        date: "February, 2024",
        runTime: [2, 49],
        location: "Greenwich, London",
        coords: ["51.5072° N", "0.1276° W"],
      },
      description: "A massive white cove, VHS, disposables camera and VFX galore.",
      keywords: ["music video", "arri alexa", "vfx", "uk rap"],
      content: {
        rollingTitle: [
          " We buy tequila in crates and tell girls bring their mates.",
          " Now they're wet 'cause I came in with Nafe."
        ],
        splitQuote: [
          'Copped a Rolls',
          'It Came with a girl'
        ],
        minorQuote: [
          "", 
          ""
        ],
        lastQuote: [
          'Lil\' bitch,',
          'you geekin\'?'
        ],
        heroQuote: [
          'Crushin\' the molly, I\'m geekin\'.',
          '- NAFE -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/GEEKIN/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/GEEKIN/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/GEEKIN/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/GEEKIN/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/GEEKIN/trim.mp4",
        mobileVideo: "../media/main/GEEKIN/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/GEEKIN/mobile/GEEKIN_0.webp",
          placeholder: "../media/main/GEEKIN/placeholder/GEEKIN_0.webp"
        },
        {
          backgroundImage: "../media/main/GEEKIN/mobile/GEEKIN_1.webp",
          placeholder: "../media/main/GEEKIN/placeholder/GEEKIN_1.webp"
        },
        {
          backgroundImage: "../media/main/GEEKIN/mobile/GEEKIN_2.webp",
          placeholder: "../media/main/GEEKIN/placeholder/GEEKIN_2.webp"
        },
        {
          backgroundImage: "../media/main/GEEKIN/mobile/GEEKIN_3.webp",
          placeholder: "../media/main/GEEKIN/placeholder/GEEKIN_3.webp"
        },
        {
          backgroundImage: "../media/main/GEEKIN/mobile/GEEKIN_4.webp",
          placeholder: "../media/main/GEEKIN/placeholder/GEEKIN_4.webp"
        },
        {
          backgroundImage: "../media/main/GEEKIN/mobile/GEEKIN_6.webp",
          placeholder: "../media/main/GEEKIN/placeholder/GEEKIN_6.webp"
        },
        {
          backgroundImage: "../media/main/GEEKIN/mobile/GEEKIN_5.webp",
          placeholder: "../media/main/GEEKIN/placeholder/GEEKIN_5.webp"
        }
        
      ]
    },
    {
      title: "Moi",
      artist: "Central Cee",
      feature: ["Raye"],
      vimeo: "https://vimeo.com/1057120321/62b2077eae",
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        production: "DON PROD",
        director: "DON PROD",
        producer: "Aleksandra Zalesinska",
        dop: "Michael R. Johnson",
        editor: "DON PROD",
        colourist: "Nick Lindell-Wright",
        Development: "Kodak Pinewood",
        Photographer: "Jamie Ramsey",
        first_ac: "Joe Hill",
        first_ad: "Ben Gomm"
      },
      meta: {
        date: "September, 2024",
        runTime: [2, 55],
        location: ["London, UNITED KINGDOM",  "Calais + Paris, FRANCE"],
        coords: null,
      },
      description: "4 day in pARIS, RUN AND GUN, 16MM FILM",
      keywords: ["uk rap", "16mm", "arri sr2"],
      content: {
        rollingTitle: [
          " What would you do in Cee's position? They gave me a fish, they ain't teach me fishing. ",
          " Back in the day, I had decent bitches. But they ain't got nothin' on my recent women. "
        ],
        splitQuote: [
          'BACK IN THE DAY',
          'I HAD DECENT'
        ],
        minorQuote: [
          "GOOD BOY", 
          "'TILL I STARTED SINNIN'"
        ],
        lastQuote: [
          'Je pense',
          'à toi'
        ],
        heroQuote: [
          'Talk about drill, gotta mention moi.',
          '- Cee -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/MOI/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/MOI/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/MOI/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/MOI/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/MOI/trim.mp4",
        mobileVideo: "../media/main/MOI/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_0.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_0.webp"
        },
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_1.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_1.webp"
        },
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_2.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_2.webp"
        },
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_3.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_3.webp"
        },
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_4.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_4.webp"
        },
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_5.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_5.webp"
        },
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_6.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_6.webp"
        },
        {
          backgroundImage: "../media/main/MOI/mobile/MOI_7.webp",
          placeholder: "../media/main/MOI/placeholder/MOI_7.webp"
        }
      ]
    },
    {
      title: "Kindness For Weakness",
      artist: "Digga D",
      feature: ["Raye"],
      vimeo: "https://vimeo.com/1057120633/7433f11b60",
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        director: "DON PROD",
        producer: "Adam Watts",
        first_ad: "Jahn Ramis",
        first_ac: "Mindaugas Kairys",
        dop: "Michael R. Johnson",
        editor: "Samuel Maton",
        photographer: "Ollie Buckle"
      },
      meta: {
        date: "August, 2023",
        runTime: [2, 43],
        location: "Castle Gibson, London",
        coords: ["51.5452° N", "0.0749° W"],
      },
      description: "A reflection of Digga's achievements. ",
      keywords: ["uk rap", "arri alexa"],
      content: {
        rollingTitle: [
          " N***as take my kindness for weakness. ",
          " I see their weakness, but they're showin' me in kindness. ",
        ],
        splitQuote: [
          'BELIEVE IN MYSELF',
          'KNOW I\'M ABLE'
        ],
        minorQuote: [
          "No backbone.", 
          "N***AS spineless"
        ],
        lastQuote: [
          'FULLY,',
          'FULLY UP'
        ],
        heroQuote: [
          'Fuck beggin\' for a seat, I\'ma build my own table',
          '- Digga D -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/KINDNESSFORWEAKNESS/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/KINDNESSFORWEAKNESS/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/KINDNESSFORWEAKNESS/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/KINDNESSFORWEAKNESS/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/KINDNESSFORWEAKNESS/trim.mp4",
        mobileVideo: "../media/main/KINDNESSFORWEAKNESS/trim_mobile.mp4"
      },
      tags : [1],
      stills: [
        {
          backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_0.webp",
          placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_0.webp"
        },
        {
          backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_1.webp",
          placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_1.webp"
        },
        {
          backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_2.webp",
          placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_2.webp"
        },
        {
          backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_3.webp",
          placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_3.webp"
        },
        {
          backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_4.webp",
          placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_4.webp"
        },
        {
          backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_5.webp",
          placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_5.webp"
        },
        {
          backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_6.webp",
          placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_6.webp"
        },
        {
          backgroundImage: "../media/main/KINDNESSFORWEAKNESS/mobile/KINDNESSFORWEAKNESS_7.webp",
          placeholder: "../media/main/KINDNESSFORWEAKNESS/placeholder/KINDNESSFORWEAKNESS_7.webp"
        }
      ]
    },
    // {
    //   title: "Quarter Past 3",
    //   artist: "Fredo",
    //   feature: "Eric IV",
    //   vimeo: "MISSING", //MISSING
    //   aspectRatio: 16/9,
    //   tags : [1, 4],
    //   credits: {
    //     director: "DON PROD",
    //     executiveProducer: "Teoman Han",
    //     producer: "Alex Alleyne",
    //     gaffer: "Qwase Anderson",
    //     spark: "Kenny Holder",
    //     colourProducer: "George Blomiley",
    //     colourist: "Alexandre Nerzic",
    //     photographer: "Alex Alleyne"
    //   },
    //   meta: {
    //     runTime: ["MISSING"], // MISSING
    //     coords: ["13.1939° N", "59.5432° W"],
    //     location: "London + Barbados"
    //   },
    //   content: {
    //     rollingTitle: [
    //       " When they ask for you number on the side of the street. ",
    //       " Tell them guys, that you're ridin' with me. ",
    //     ],
    //     splitQuote: [
    //       'Placin\' the blame',
    //       'I just take it again'
    //     ],
    //     minorQuote: [
    //       "JUST TRYNA", 
    //       "SET YOU FREE"
    //     ],
    //     lastQuote: [
    //       'IS YOU REALLY',
    //       'ALL I NEED?'
    //     ],
    //     heroQuote: [
    //       'Tell me what you need, baby girl, it\'s on me',
    //       '- Fredo -'
    //     ]
    //   },
    //   thumbnails: {
    //     placeholder: "../media/main/QUARTERPAST/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
    //     mobile: "../media/main/QUARTERPAST/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
    //     laptop: "../media/main/QUARTERPAST/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
    //     desktop: "../media/main/QUARTERPAST/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
    //   },
    //   gifStyling: {
    //     backgroundImage: "../media/main/QUARTERPAST/trim.mp4" // The gif used for the thumbnail
    //   },
    //   tags : [1],
    //   stills: [
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_0.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_0.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_1.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_1.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_2.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_2.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_3.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_3.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_4.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_4.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_5.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_5.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_6.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_6.webp"
    //     },
    //     {
    //       backgroundImage: "../media/main/QUARTERPAST/mobile/QUARTERPAST_7.webp",
    //       placeholder: "../media/main/QUARTERPAST/placeholder/QUARTERPAST_7.webp"
    //     }
    //   ]
    // },
    {
      title: "ILLEGAL",
      artist: "Headie One",
      feature: null,
      vimeo: "https://vimeo.com/1057121115/30ece6bb80", 
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        director: "DON PROD",
        producer: "Adam Watts",
        dop: "Michael R. Johnson",
        first_ac: "Mindaugas Kairys",
        bts: "Jamie Ramsey",
        pa: "Lucy Chappell",
        pa: "Daisy White"
      },
      meta: {
        date: "August 2022",
        runTime: [3, 39], 
        location: "Ramsgate, London",
        coords: ["",""],
        date: "Summer 24",
      },
      description: "Parrots, helicopters and supercars. All in red.",
      keywords: ["music video", "uk drill", "arri alexa"],
      content: {
        rollingTitle: [
          " Still outside, no face, no case.",
          " 'cah they still say my name, and bros caught case."
        ],
        splitQuote: [
          ' I\'m legal handlin\'',
          'Shit Illegal'
        ],
        minorQuote: [
          "Wrist so wet", 
          "Lookin\' like a sea view"
        ],
        lastQuote: [
          'Am I legal,',
          'Or ILLEGAL?'
        ],
        heroQuote: [
          'It\'s still PTSD when I hear that nina.',
          '- HEADIE ONE -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/HEADIE/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/HEADIE/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/HEADIE/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/HEADIE/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/HEADIE/trim.mp4",
        mobileVideo: "../media/main/HEADIE/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_0.webp",
          placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_0.webp"
        },
        {
          backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_1.webp",
          placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_1.webp"
        },
        {
          backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_2.webp",
          placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_2.webp"
        },
        {
          backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_3.webp",
          placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_3.webp"
        },
        {
          backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_4.webp",
          placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_4.webp"
        },
        {
          backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_5.webp",
          placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_5.webp"
        },
        {
          backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_6.webp",
          placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_6.webp"
        },
        {
          backgroundImage: "../media/main/HEADIE/mobile/ILLEGAL_7.webp",
          placeholder: "../media/main/HEADIE/placeholder/ILLEGAL_7.webp"
        }
      ]
    },
    {
      title: "Tipsy",
      artist: "Headie One",
      feature: ["Aitch"],
      vimeo: "https://vimeo.com/1057125438/ba4aa3b1e4", 
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        director: "DON PROD",
        dop: "Michael R. Johnson",
        producer: "Jahn Ramis",
        producer: "Quinn Titsworth",
        commissioner: "Quinn Titsworth",
        editor: "DON PROD",
        colourist: "Loren James White"
      },
      meta: {
        date: "June 2021",
        runTime: [2, 49], 
        location: "Marbella, Spain",
        coords: ["36.5103° N", "4.8853° W"],
      },
      description: "Summer vibes on 16mm in Marbella. ",
      keywords: ["music video", "uk rap", "arri sr2"],
      content: {
        rollingTitle: [
          " Still outside, no face, no case.",
          " 'cah they still say my name, and bros caught case."
        ],
        splitQuote: [
           " Toxic relations.",
            "In custom 'til they freed her."
        ],
        minorQuote: [
          "I guarantee", 
          "I leave shawty curled up"
        ],
        lastQuote: [
          'HONEY',
          'GOT ME TIPSY'
        ],
        heroQuote: [
          'I sip rum, I guarantee I leave shawty curled up.',
          '- HEADIE ONE -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/TIPSY/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/TIPSY/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/TIPSY/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/TIPSY/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/TIPSY/trim.mp4",
        mobileVideo: "../media/main/TIPSY/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_0.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_0.webp"
        },
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_1.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_1.webp"
        },
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_2.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_2.webp"
        },
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_3.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_3.webp"
        },
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_4.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_4.webp"
        },
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_5.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_5.webp"
        },
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_6.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_6.webp"
        },
        {
          backgroundImage: "../media/main/TIPSY/mobile/TIPSY_7.webp",
          placeholder: "../media/main/TIPSY/placeholder/TIPSY_7.webp"
        }
      ]
    },
    {
      title: "Dat Way",
      artist: "Krept & Konan",
      feature: null,
      vimeo: "https://vimeo.com/1057126093/fbad1d09b6", 
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        director: "DON PROD",
        producer: "Adam Watts",
        first_ad: "Jahn Ramis",
        dop: "Michael R. Johnson",
        first_ac: "Fabio Olgiati",
        trainee: "Abhishek Thapa",
        steadicam: "Lee David Brown",
        gaffer: "Sachin Parma",
        spark: "Mazin",
        photography: "Jamie Ramsey",
        photography: "Thomas Morgan"
      },
      meta: {
        date: "February 2023",
        runTime: [4, 12], 
        location: "London, UK",
        coords: ["51.5072° N", "0.1276° W"],
      },
      description: "16mm + the block = cheat code",
      keywords: ["16MM", "uk drill", "arri sr2"],
      content: {
          rollingTitle: [
            " I'm in, then I'm out, like I fucked mans girl.",
            " I'm in, then I'm out, when I press this ting."
          ],
          splitQuote: [
            'Are You Paid?',
            'Of Course.'
          ],
          minorQuote: [
            "Bad man", 
            "With a good heart"
          ],
          lastQuote: [
            'IM IN THEN,',
            'IM OUT.'
          ],
          heroQuote: [
            'Fuck who you listenin\' to',
            '- K&K -'
          ]
      },
      thumbnails: {
        placeholder: "../media/main/DATWAYKREPT/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/DATWAYKREPT/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/DATWAYKREPT/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/DATWAYKREPT/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/DATWAYKREPT/trim.mp4",
        mobileVideo: "../media/main/DATWAYKREPT/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_0.webp",
          placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_0.webp"
        },
        {
          backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_1.webp",
          placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_1.webp"
        },
        {
          backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_2.webp",
          placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_2.webp"
        },
        {
          backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_3.webp",
          placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_3.webp"
        },
        {
          backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_4.webp",
          placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_4.webp"
        },
        {
          backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_5.webp",
          placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_5.webp"
        },
        {
          backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_6.webp",
          placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_6.webp"
        },
        {
          backgroundImage: "../media/main/DATWAYKREPT/mobile/DATWAY_7.webp",
          placeholder: "../media/main/DATWAYKREPT/placeholder/DATWAY_7.webp"
        }
      ]
    },
    {
      title: "I Know",
      artist: "LeoStayTrill",
      feature: ["Jay Baloo", "Ade STP"],
      vimeo: "https://vimeo.com/1057126487/c00a291129", 
      aspectRatio: 4/3,
      tags : [1],
      credits: {
        director: "DON PROD",
        dop: "Michael R. Johnson",
        second_AC: "Antione Law",
        gaffer: "London Lighting",
        continuity: "Polly Coombes",
        graphics: "Harry Clean",
        VFX: "Federico Bocchi"
      },
      meta: {
        date: "April 2024",
        runTime: [2, 15], 
        location: "London, UK",
        coords: ["51.5072° N", "0.1276° W"],
      },
      description: "Experimenting with film. ",
      keywords: ["FILM", "Experimental", "vfx"],
      content: {
        rollingTitle: [
          " The badder make pounds, I know, I know.",
          " Tell her bend down, how low, how low?"
        ],
        splitQuote: [
          'On her Insta',
          'Unfollowing now'
        ],
        minorQuote: [
          "How low?", 
          "How low?"
        ],
        lastQuote: [
          'king of',
          'my hood'
        ],
        heroQuote: [
          'You talk Ps, but I heard that you cap.',
          '- Leo -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/IKNOW/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/IKNOW/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/IKNOW/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/IKNOW/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/IKNOW/trim.mp4",
        mobileVideo: "../media/main/IKNOW/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_0.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_0.webp"
        },
        
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_2.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_2.webp"
        },
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_1.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_1.webp"
        },
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_3.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_3.webp"
        },
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_4.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_4.webp"
        },
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_5.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_5.webp"
        },
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_6.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_6.webp"
        },
        {
          backgroundImage: "../media/main/IKNOW/mobile/IKNOW_7.webp",
          placeholder: "../media/main/IKNOW/placeholder/IKNOW_7.webp"
        }
      ]
    },
    {
      title: "Escape",
      artist: "Nemzzz",
      feature: null,
      vimeo: "https://vimeo.com/1057132558/675fc79b7c", 
      aspectRatio: 80/53,
      tags : [1],
      credits: {
        director: "DON PROD",
        dop: "Michael R. Johnson",
        photography: "Jamie Ramsey",
        gaffer: "London Lighting",
        first_ac: "Mindaugas Kairys",
        second_ac: "Antoine Law",
        colour_house: "Creative Outpost",
        colourist: "Alexandre Nerzic",
        sound_design: "Kai Goodrem"
      },
      meta: {
        date: "July 2024",
        runTime: [2, 8], 
        location: "London, UK",
        coords: ["51.5072", "0.1276° W"],
      },
      description: "Shot, edited and released in under 48 hours.",
      keywords: ["LIVE", "uk rap", "arri alexa"],
      content: {
        rollingTitle: [
          " What is it now? I stood on business and I made it clear.",
          " I'm over it now, you done all this to make me look weird."
        ],
        splitQuote: [
          'If it\'s you or me',
          'that\'s peak on you'
        ],
        minorQuote: [
          "Speak w chest", 
          "no need to shout"
        ],
        lastQuote: [
          'just mad',
          'you\'re broke'
        ],
        heroQuote: [
          'So many questions, who do I ask? Where do I go from here?',
          '- Nemzzz -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/ESCAPE/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/ESCAPE/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/ESCAPE/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/ESCAPE/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/ESCAPE/trim.mp4",
        mobileVideo: "../media/main/ESCAPE/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_0.webp",
          placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_0.webp"
        },
        {
          backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_1.webp",
          placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_1.webp"
        },
        {
          backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_2.webp",
          placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_2.webp"
        },
        {
          backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_3.webp",
          placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_3.webp"
        },
        {
          backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_4.webp",
          placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_4.webp"
        },
        {
          backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_5.webp",
          placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_5.webp"
        },
        {
          backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_6.webp",
          placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_6.webp"
        },
        {
          backgroundImage: "../media/main/ESCAPE/mobile/ESCAPE_7.webp",
          placeholder: "../media/main/ESCAPE/placeholder/ESCAPE_7.webp"
        }
      ]
    },
    {
      title: "L's",
      artist: "Nemzzz",
      feature: null,
      vimeo: "https://vimeo.com/1057621823/0ec385a816", 
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        director: "DON PROD",
        dop: "Michael R. Johnson",
        first_ac: "Christian Wood",
        first_ac: "Mindaugas Kairys",
        Gaffer: "London Lighting",
        second_ac: "Antione Law",
        photography: "Jamie Ramsey",
        editor: "Georgie Curran",
        colourist: "Jared Rosenthal",
        titles: "Coi Tran",
        film_processing: "Kodak"
      },
      meta: {
        date: "February 2024",
        runTime: [2, 1], 
        location: "London, UK",
        coords: ["51.5072", "0.1276° W"],
      },
      description: "One of our personal favourites for Nemzzz. ",
      keywords: ["music video", "uk rap", "arri sr 2"],
      content: {
        rollingTitle: [
          " What is it now? I stood on business and I made it clear.",
          " I'm over it now, you done all this to make me look weird."
        ],
        splitQuote: [
          'Better than who?',
          'Better than me?'
        ],
        minorQuote: [
          'FUCK MY EX',
          'FUCK MY EX'
          
        ],
        lastQuote: [
          "My L's come", "with a V"
        ],
        heroQuote: [
          'So many parties missed, now I can sip my cognac.',
          '- Nemzzz -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/LS/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/LS/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/LS/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/LS/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/LS/trim.mp4",
        mobileVideo: "../media/main/LS/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/LS/mobile/LS_1.webp",
          placeholder: "../media/main/LS/placeholder/LS_1.webp"
        },
        {
          backgroundImage: "../media/main/LS/mobile/LS_2.webp",
          placeholder: "../media/main/LS/placeholder/LS_2.webp"
        },
        {
          backgroundImage: "../media/main/LS/mobile/LS_3.webp",
          placeholder: "../media/main/LS/placeholder/LS_3.webp"
        },
        {
          backgroundImage: "../media/main/LS/mobile/LS_4.webp",
          placeholder: "../media/main/LS/placeholder/LS_4.webp"
        },
        {
          backgroundImage: "../media/main/LS/mobile/LS_5.webp",
          placeholder: "../media/main/LS/placeholder/LS_5.webp"
        },
        {
          backgroundImage: "../media/main/LS/mobile/LS_6.webp",
          placeholder: "../media/main/LS/placeholder/LS_6.webp"
        },
        {
          backgroundImage: "../media/main/LS/mobile/LS_0.webp",
          placeholder: "../media/main/LS/placeholder/LS_0.webp"
        },
        {
          backgroundImage: "../media/main/LS/mobile/LS_7.webp",
          placeholder: "../media/main/LS/placeholder/LS_7.webp"
        },
      ]
    },
    {
      title: "Its Us",
      artist: "Nemzzz",
      feature: ["Lil Yachty"],
      vimeo: "https://vimeo.com/1057132843/27b61b505d", 
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        director: "DON PROD",
        dop: "Michael R. Johnson",
        first_ac: "Mindaugas Kairys",
        second_ac: "Rory Thomas",
        Gaffer: "London Lighting",
        photography: "Jamie Ramsey",
        sound_design: "Kai Goodrem",
        title: "Sam Bellinger"
      },
      meta: {
        date: "March 2024",
        runTime: [1, 58], 
        location: "London, UK",
        coords: ["51.5072", "0.1276° W"],
      },
      description: "Big UK x US linkup. Lil Boat on a boat.",
      keywords: ["music video", "uk rap", "arri sr2", "vfx"],
      content: {
        rollingTitle: [
          " I just told bro, It's us. I hit that one, no fuss.",
          " I hit that one, then cut, ay, skrrt, I'm in a rush."
        ],
        splitQuote: [
          'TIRED OF THESE HOES',
          'I NEED YOUR LOVE'
        ],
        minorQuote: [
          'MY HATERS',
          'I WISH YOU WELL'
          
        ],
        lastQuote: [
          "I TOLD BRO,", "IT\'s US."
        ],
        heroQuote: [
          'All my opps still broke? Oh my God, what a bummer.',
          '- Yachty -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/ITSUS/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/ITSUS/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/ITSUS/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/ITSUS/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/ITSUS/trim.mp4",
        mobileVideo: "../media/main/ITSUS/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_4.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_4.webp"
        },
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_7.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_7.webp"
        },
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_0.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_0.webp"
        },
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_2.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_2.webp"
        },
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_3.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_3.webp"
        },
        
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_6.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_6.webp"
        },
        
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_1.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_1.webp"
        },
        {
          backgroundImage: "../media/main/ITSUS/mobile/ITSUS_5.webp",
          placeholder: "../media/main/ITSUS/placeholder/ITSUS_5.webp"
        }
      ]
    },
    {
      title: "PTSD",
      artist: "Nemzzz",
      feature: null,
      vimeo: "https://vimeo.com/1057133036/d25e03544e", 
      aspectRatio: 80/53, //MISSING
      tags : [1],
      credits: {
        director: "DON PROD",
        dop: "Michael R. Johnson",
        first_ac: "Ken Carson",
        photography: "Jamie Ramsey",
        editor: "Georgie Curran",
        graphics: "Coi Tran",
        sound_design: "Kai Goodrem",
        dogs: "Hazeline"
      },
      meta: {
        date: "February 2024",
        runTime: [2, 15], 
        coords: ["53.4808° N", "2.2426° W"],
        location: "Manchester, UK",
      },
      description: "Multimedia masterpiece.",
      keywords: ["music video", "uk rap", "arri alexa", "vfx"],
      content: {
        rollingTitle: [
          " Overthink too much, I get distracted, start to deep it.",
          " me, I just deal with people exactly how they treat me."
        ],
        splitQuote: [
          'I know that I hurt',
          'I cut you off'
        ],
        minorQuote: [
          'Stay in my bag',
          'not in my feelings'
          
        ],
        lastQuote: [
          "GET OUT", "the way"
        ],
        heroQuote: [
          'No one checked on me when I needed.',
          '- Nemzzz -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/PTSD/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/PTSD/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/PTSD/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/PTSD/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/PTSD/trim.mp4",
        mobileVideo: "../media/main/PTSD/trim_mobile.mp4"
      },
      stills: [
        
        {
          backgroundImage: "../media/main/PTSD/mobile/PTSD_1.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_1.webp"
        },{
          backgroundImage: "../media/main/PTSD/mobile/PTSD_0.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_0.webp"
        },
        {
          backgroundImage: "../media/main/PTSD/mobile/PTSD_2.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_2.webp"
        },
        {
          backgroundImage: "../media/main/PTSD/mobile/PTSD_3.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_3.webp"
        },
        {
          backgroundImage: "../media/main/PTSD/mobile/PTSD_4.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_4.webp"
        },
        {
          backgroundImage: "../media/main/PTSD/mobile/PTSD_5.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_5.webp"
        },
        {
          backgroundImage: "../media/main/PTSD/mobile/PTSD_6.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_6.webp"
        },
        {
          backgroundImage: "../media/main/PTSD/mobile/PTSD_7.webp",
          placeholder: "../media/main/PTSD/placeholder/PTSD_7.webp"
        }
      ]
      
    },
    {
      title: "RUNTZ",
      artist: "Smokes",
      feature: null,
      vimeo: "https://vimeo.com/1057133184/5c0f1a692a", 
      aspectRatio: 4/3,
      tags : [1],
      credits: {
        director: "DON PROD",
        dop: "Michael R. Johnson",
        first_ac: "Mindaugas Kairys",
        gaffer: "Sachin Parma",
        warehouse: "London Lighting",
        vfx: "Federico Bocchi",
        titles: "Archie Griffifths"
      },
      meta: {
        date: "January 2023",
        runTime: [3, 23], 
        coords: ["51.5072", "0.1276° W"],
        location: "London, UK",
      },
      description: "VFX bonanza.",
      keywords: ["music video", "uk drill", "arri alexa", "vfx"],
      content: {
        rollingTitle: [
          " TURN UP AT YOUR BLOCK FOR THE LITTLEST THINGS.",
          " I DONT CARE WHAT YOU LIFT IN THE GYM. THESE HOLLOWS WILL TEAR OUT HIS RIMS."
        ],
        splitQuote: [
          'ALWAYS ON VIOLENCE',
          'NEVER ON CHATTINGS'
        ],
        minorQuote: [
          'TWENTY THREE',
          'AND I RUN MY BLOCK'
          
        ],
        lastQuote: [
          "REAL LIFE", "GANG TIES"
        ],
        heroQuote: [
          'I\'M A DANGEROUS YUTE, YOU CAN CHECK MY CREDENTIALS.',
          '- Smokes -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/RUNTZ/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/RUNTZ/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/RUNTZ/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/RUNTZ/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/RUNTZ/trim.mp4",
        mobileVideo: "../media/main/RUNTZ/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_0.webp",
          placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_0.webp"
        },
        {
          backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_7.webp",
          placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_7.webp"
        },
        {
          backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_2.webp",
          placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_2.webp"
        },
        {
          backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_3.webp",
          placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_3.webp"
        },
        {
          backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_4.webp",
          placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_4.webp"
        },
        {
          backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_5.webp",
          placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_5.webp"
        },
        {
          backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_1.webp",
          placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_1.webp"
        },
        {
          backgroundImage: "../media/main/RUNTZ/mobile/RUNTZ_6.webp",
          placeholder: "../media/main/RUNTZ/placeholder/RUNTZ_6.webp"
        }
      ]
    },
    // {
    //   title: "Villains",
    //   artist: "Trapstar",
    //   feature: "",
    //   vimeo: "https://vimeo.com/1029408858/385e1324c7", 
    //   aspectRatio: "MISSING", //MISSING
    //   tags : [1, 4],
    //   credits: {
    //     director: "DON PROD",
    //     dop: "Michael R. Johnson",
    //     producer: "Adam Watts",
    //     first_ad: "Jahn Ramis",
    //     second_ad: "Luke Kimble Williams",
    //     pa1: "Olivia Flashman",
    //     pa2: "Hannah Gray",
    //     pa3: "James Edward Keating",
    //     pa4: "Laurent C. Durham",
    //     first_ac: "Harry Coleman",
    //     scondAC: "Flynn Denisson",
    //     colourist: "Yunus Aktas",
    //     sound_design: "Ayo Douson",
    //     score: "Michael Cryne"
    //   },
    //   meta: {
    //     runTime: [1, 27], 
    //     location: "London + Snowdonia"
    //   } 
    // },
    {
      title: "Shooters",
      artist: "Trapstar",
      feature: null,
      vimeo: "https://vimeo.com/1057133425/dcf0ccc390", 
      aspectRatio: 4/3,
      tags : [2],
      credits: {
        producer: "Adam John Watts",
        pa: "Tomas Leslie",
        first_ad: "Billy French",
        second_ad: "Jodie Joy",
        thirdAD: "Esme Vimes",
        runner: "Fergus Rae Smith",
        dop: "Michael R. Johnson",
        first_ac: "Mindaugas Kairys",
        editor: "Archie Erskine",
        colourist: "Alexandre Nerzic",
        colourProducer: "Alexander Wilson-Thame",
        sound_design: "George Blomiley",
        leadBaller: "Spillberg",
        deadBaller: "Daniels Dunia"
      },
      meta: {
        date: "July 2024",
        runTime: [1, 12],
        coords: ["51.5072", "0.1276° W"],
        location: "London",
      },
      description: "Shooting hoops at sunset in East London. ",
      keywords: ["commercial", "arri alexa"],
      content: {
        rollingTitle: [
          " TRAPSTAR SHOOTERS. TRAPSTAR SHOOTERS. TRAPSTAR SHOOTERS. TRAPSTAR SHOOTERS. ",
          " TRAPSTAR SHOOTERS. TRAPSTAR SHOOTERS. TRAPSTAR SHOOTERS. "
        ],
        splitQuote: [
          'ME, TALK??',
          'PUT SOME BREAD ON IT.'
        ],
        minorQuote: [
          '',
          ''
        ],
        lastQuote: [
          "one on one", "RIGHT NOW"
        ],
        heroQuote: [
          '',
          ''
        ]
      },
      thumbnails: {
        placeholder: "../media/main/SHOOTERS/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/SHOOTERS/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/SHOOTERS/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/SHOOTERS/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/SHOOTERS/trim.mp4",
        mobileVideo: "../media/main/SHOOTERS/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_5.webp",
          placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_5.webp"
        },
        {
          backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_0.webp",
          placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_0.webp"
        },
        {
          backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_1.webp",
          placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_1.webp"
        },
        
        {
          backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_3.webp",
          placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_3.webp"
        },
        {
          backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_4.webp",
          placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_4.webp"
        },
        {
          backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_7.webp",
          placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_7.webp"
        },
        {
          backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_6.webp",
          placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_6.webp"
        },
        
        {
          backgroundImage: "../media/main/SHOOTERS/mobile/SHOOTERS_2.webp",
          placeholder: "../media/main/SHOOTERS/placeholder/SHOOTERS_2.webp"
        },
      ]
    },
    {
      title: "Evicted",
      artist: "Nemzzz",
      feature: null,
      vimeo: "https://vimeo.com/1057132656/35bc884a90", 
      aspectRatio: 240/167,
      tags : [1],
      credits: {
        director: "DON PROD",
        DOP: "Michael R. Johnson",
        first_ac: "@Cine.den",
        second_ac: "@oliFilm24",
        photographer: "@lifeofteej",
        socials: "@don.socials",
      },
      meta: {
        date: "October 2024",
        runTime: [2, 41],
        coords: ["51.5072", "0.1276° W"],
        location: "London",
      },
      description: "Heart gone cold like Palmer!",
      keywords: ["music video", "uk rap", "arri alexa"],
      content: {
        rollingTitle: [
          "I just counted a healthy stack and gave that straight to my dad. ",
          "Move mumsy out of the hood, one way so we can't go back. "
        ],
        splitQuote: [
          'Don\'t run',
          'Don\'t trip'
        ],
        minorQuote: [
          '',
          ''
        ],
        lastQuote: [
          "gone cold","like palmer"
        ],
        heroQuote: [
          'She wanna question me, ayy don\'t ask me bae, go ask Reddit.',
          ' - Nemzzz - '
        ]
      },
      thumbnails: {
        placeholder: "../media/main/EVICTED/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/EVICTED/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/EVICTED/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/EVICTED/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/EVICTED/trim.mp4",
        mobileVideo: "../media/main/EVICTED/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_5.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_5.webp"
        },
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_0.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_0.webp"
        },
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_1.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_1.webp"
        },
        
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_3.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_3.webp"
        },
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_4.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_4.webp"
        },
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_7.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_7.webp"
        },
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_6.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_6.webp"
        },
        
        {
          backgroundImage: "../media/main/EVICTED/mobile/EVICTED_2.webp",
          placeholder: "../media/main/EVICTED/placeholder/EVICTED_2.webp"
        },
      ]
    },
    {
      title: "WENT UP",
      artist: "Kairo Keyz",
      feature: null,
      vimeo: "https://vimeo.com/1057125811/991b0103f3", 
      aspectRatio: 1920/1327,
      tags : [1],
      credits: {
        director: "DON PROD",
        produceer: "@alizzieeee",
        dop: "Michael R. Johnson",
        photographer: "@ramseyramone",
        first_ac: "@cine.den",
        second_ac: "@oliFilm24",
        gaffer: "@jedclist_lighting",
        spark: "@sam_1sp",
        spark: "@arjunvellcattaree",
        edit: "@harry.tatem",
        socials: "@don.socials",
      },
      meta: {
        date: "October 2024",
        runTime: [2, 2],
        coords: ["51.5072", "0.1276° W"],
        location: "London",
      },
      description: "Short but sweet. Pulled out all the tricks on this one.",
      keywords: ["music video", "uk rap", "arri alexa", "vfx"],
      content: {
        rollingTitle: [
          "Left hand full up of fifties, look at my hand, man carryin\' \'nough ",
          "I'm in the dance with bad ones throwin' up ones, they're pickin' it up "
        ],
        splitQuote: [
          'bands went up ',
          'hate went up '
        ],
        minorQuote: [
          'Hear man chat,',
          'Same thing.'
        ],
        lastQuote: [
          "I like my", "bitches bad"
        ],
        heroQuote: [
          'Hate when I hear man talkin\' \'nough',
          ' - Kairo - '
        ]
      },
      thumbnails: {
        placeholder: "../media/main/WENTUP/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/WENTUP/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/WENTUP/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/WENTUP/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/WENTUP/trim.mp4",
        mobileVideo: "../media/main/WENTUP/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/WENTUP/mobile/WENTUP_5.webp",
          placeholder: "../media/main/WENTUP/placeholder/WENTUP_5.webp"
        },
        {
          backgroundImage: "../media/main/WENTUP/mobile/WENTUP_0.webp",
          placeholder: "../media/main/WENTUP/placeholder/WENTUP_0.webp"
        },
        {
          backgroundImage: "../media/main/WENTUP/mobile/WENTUP_1.webp",
          placeholder: "../media/main/WENTUP/placeholder/WENTUP_1.webp"
        },
        
        {
          backgroundImage: "../media/main/WENTUP/mobile/WENTUP_3.webp",
          placeholder: "../media/main/WENTUP/placeholder/WENTUP_3.webp"
        },
        {
          backgroundImage: "../media/main/WENTUP/mobile/WENTUP_4.webp",
          placeholder: "../media/main/WENTUP/placeholder/WENTUP_4.webp"
        },
        {
          backgroundImage: "../media/main/WENTUP/mobile/WENTUP_7.webp",
          placeholder: "../media/main/WENTUP/placeholder/WENTUP_7.webp"
        },
        {
          backgroundImage: "../media/main/WENTUP/mobile/WENTUP_6.webp",
          placeholder: "../media/main/WENTUP/placeholder/WENTUP_6.webp"
        },
        
        {
          backgroundImage: "../media/main/WENTUP/mobile/WENTUP_2.webp",
          placeholder: "../media/main/WENTUP/placeholder/WENTUP_2.webp"
        },
      ]
    },
    {
      title: "MORE MONEY MORE PROBLEMS",
      artist: "HEADIE ONE",
      feature: null,
      vimeo: "https://vimeo.com/1057125068/98fe1ee28f", 
      aspectRatio: 16/9,
      tags : [1],
      credits: {
        director: "DON PROD",
        first_ac: "Mindaugas Kairys",
        socials: "@don.socials",
      },
      meta: {
        date: "August 2023",
        runTime: [3, 3],
        coords: null,
        location: ["Dubai, UAE", "HELSINKI, RUSSIA",  "Brussels, BELGIUM", "London, UNITED KINGDOM" ]
      },
      keywords: ["music video", "uk rap"],
      content: {
        rollingTitle: [
          'They want me back in HMP, true, that\'s where this all started. ',
          'I\'m a walkin\' target, I seen one of my dogs turn crassis. '
        ],
        splitQuote: [
          "More money", "more problems"
        ],
        minorQuote: [
          'already',
          'Made history'
        ],
        lastQuote: [
          "walking", "target"
        ],
        heroQuote: [
          'More money, more problems, I been feelin\' like Biggie',
          '- Headie -'
        ]
      },
      thumbnails: {
        placeholder: "../media/main/MOREMONEY/thumbnails/placeholder.webp", // used as placeholder for home tiles (100px)
        mobile: "../media/main/MOREMONEY/thumbnails/mobile.webp", //used as hero on shoot page for mobile (600px)
        laptop: "../media/main/MOREMONEY/thumbnails/tablet.webp", //used as hero on shoot page for mobile (1200px)
        desktop: "../media/main/MOREMONEY/thumbnails/desktop.webp", //used as hero on shoot page for mobile (3840px)
      },
      gifStyling: {
        backgroundImage: "../media/main/MOREMONEY/trim.mp4",
        mobileVideo: "../media/main/MOREMONEY/trim_mobile.mp4"
      },
      stills: [
        {
          backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_5.webp",
          placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_5.webp"
        },
        {
          backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_0.webp",
          placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_0.webp"
        },
        {
          backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_1.webp",
          placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_1.webp"
        },
        
        {
          backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_3.webp",
          placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_3.webp"
        },
        {
          backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_4.webp",
          placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_4.webp"
        },
        {
          backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_7.webp",
          placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_7.webp"
        },
        {
          backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_6.webp",
          placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_6.webp"
        },
        
        {
          backgroundImage: "../media/main/MOREMONEY/mobile/MOREMONEY_2.webp",
          placeholder: "../media/main/MOREMONEY/placeholder/MOREMONEY_2.webp"
        },
      ]
    },
  ]